import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import ForceChangePassword from "@/pages/ForceChangePassword";

export function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();

  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-7 h-7 animate-spin text-primary" />
      </div>
    );

  if (user === false) return <Navigate to="/login" replace />;

  if (user.must_change_password) return <ForceChangePassword />;

  if (roles && !roles.includes(user.role)) {
    return <Navigate to={user.role === "agent" ? "/app" : "/dashboard"} replace />;
  }
  return children;
}
